import Cookies from 'js-cookie';

const TokenKey = 'class30_token';
const UserIdKey = 'class30_userid';
const UserPasswordKey = 'umdata';

export function getToken () {
    return Cookies.get(TokenKey);
}

export function setToken (token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken () {
    return Cookies.remove(TokenKey);
}

export function getUserId () {
    return Cookies.get(UserIdKey);
}

export function setUserId (userId) {
    return Cookies.set(UserIdKey, userId)
}

export function removeUserId () {
    return Cookies.remove(UserIdKey);
}


export function getPassWord () {
    return Cookies.get(UserPasswordKey);
}

export function setPassWord (password) {
    return Cookies.set(UserPasswordKey, password);
}

export function removePassWord () {
    return Cookies.remove(UserPasswordKey);
}
